import { createContext } from 'react';
import { BehaviorSubject } from 'rxjs';

// Indicates whether the app runs embedded in MS Teams or as a Chrome/Edge extension or as a standalone web app.
// `null` means the check is still in progress

export type RuntimeType = {
  loading: boolean;
  runtime:
    | { type: null }
    | { type: 'MSTeams' }
    | { type: 'browser' }
    | {
        type: 'browserExtension';
        data: {
          purchaseReqNumberStream: BehaviorSubject<string | null>;
        };
      };
};

export const runtimeDefaultValue = { loading: true, runtime: { type: null } };

export const Runtime = createContext<RuntimeType>(runtimeDefaultValue);
